export enum ContractTypeEsEnum {
    SOLAR = "Solar contract",
    LIGHT_AND_GAS = "Light and gas contract",
    MAINTENANCE = "Maintenance",
    SMARTHOME = "Smarthome",
    OTHER_PRODUCTS = "Other products and services",
}
